import clsx from 'clsx';

export const PikkoJackpotPriceCounter = ({ visible, isLastChance, count }) => (
  <div
    className={clsx(
      'transition-all duration-700 ease-[cubic-bezier(0.34,1.6,0.64,1)]',
      { 'opacity-100 scale-100 translate-y-0': visible, 'opacity-0 scale-50 translate-y-4': !visible },
    )}
  >
    <span
      className="relative font-[Fredoka,sans-serif] font-bold select-none"
      style={{ fontSize: 'clamp(120px, 30vw, 180px)', letterSpacing: '2px', ...(isLastChance ? { textDecoration: 'line-through', textDecorationColor: '#6B7280', textDecorationThickness: '6px' } : {}) }}
    >
      <span
        className="absolute inset-0"
        style={{ WebkitTextStroke: isLastChance ? '8px #9CA3AF' : '5px #C89825', color: 'transparent' }}
      >
        {Math.round(count)}&euro;
      </span>
      <span
        style={{
          background: isLastChance
            ? 'linear-gradient(107.64deg, #9CA3AF 64.66%, #6B7280 100.98%)'
            : 'linear-gradient(107.64deg, #f3d349 64.66%, #F19F10 100.98%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          position: 'relative',
          filter: isLastChance ? 'drop-shadow(2px 4px 0px #9CA3AF)' : 'drop-shadow(2px 4px 0px #C89825)',
        }}
      >
        {Math.round(count)}&euro;
      </span>
    </span>
  </div>
);
